// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmDialog_description__11rpf"};